




import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import AccountCounters from '@/components/accounts/AccountCounters.vue';

@Component({
  components: {
    'account-counters': AccountCounters
  }
})
export default class AccountCountersView extends Vue {
  private get accountId(): number {
    return Number(this.$route.params.accountId);
  }
}
